const initialState = {
    user: null,
    // status: null,
    generateToken: null
  }
  
  export const AuthReducer = (state = initialState, { type, payload = {} }) => {
    switch (type) {
      case 'GENERATE_TOKEN': {
        return ({
          ...state,
          generateToken:  payload.data.data.Data.token
        })
        
      }
      case 'SIGN_IN': {
        return {
          ...state,
          user: { ...payload.data.data.Data.user },
          generateToken: payload.data.data.Data.token 
        }
      }
      case 'SIGNOUT': {
        return {
          ...state,
          user: null
        }
      }
  
      default: return state
    }
  }